import { forwardRef } from 'react';
import { cn } from '../lib/cn';
import { playSound } from '../audio/sound';

export type ButtonTone = 'gold' | 'cyan' | 'green' | 'red' | 'magenta' | 'ghost' | 'panel';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ButtonTone;
  block?: boolean;
  size?: 'md' | 'xl';
  /** Тихий режим — без клацання (наприклад, у кабінеті батьків). */
  mute?: boolean;
  loading?: boolean;
}

const TONE_CLASS: Record<ButtonTone, string> = {
  gold: 'lk-btn--gold',
  cyan: 'lk-btn--cyan',
  green: 'lk-btn--green',
  red: 'lk-btn--red',
  magenta: 'lk-btn--magenta',
  ghost: 'lk-btn--ghost',
  panel: '',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { tone = 'panel', block, size = 'md', mute, loading, className, onClick, children, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={rest.type ?? 'button'}
      className={cn(
        'lk-btn',
        TONE_CLASS[tone],
        block && 'lk-btn--block',
        size === 'xl' && 'lk-btn--xl',
        className,
      )}
      onClick={(event) => {
        if (!mute) playSound('tap');
        onClick?.(event);
      }}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="lk-anim-pulse inline-block h-4 w-4 rounded-full bg-current" /> : null}
      {children}
    </button>
  );
});
